/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import EditIcon from '@mui/icons-material/Edit';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../store/UploadGSInfo';

interface Props {
    handleUploadGsInfoDialogClick: Function
    selectedManual: any
    UpdateGSInfoData: Function
}
class EditGSInfo extends React.Component<Props, {}>{
    handleEditClick = async () => {
        this.props.handleUploadGsInfoDialogClick(true);
        await this.props.UpdateGSInfoData(this.props.selectedManual);
    };
    render() {
        return (
            <div>
                <EditIcon className="editColor" onClick={this.handleEditClick} style={{ cursor: 'pointer' }} />
            </div>
        );
    }
}
const mapStateToProps = (state: any) => ({
    selectedManual: state.viewGeneralServiceInformation.selectedBulletin
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps, mapDispatchtoProps
)
    (EditGSInfo);
